// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"1a3c9d29","375":"05b8769b"}[chunkId] + ".chunk.css";
};